import { render, staticRenderFns } from "./officeVehicleList.vue?vue&type=template&id=f8fd1484&scoped=true"
import script from "./officeVehicleList.vue?vue&type=script&lang=js"
export * from "./officeVehicleList.vue?vue&type=script&lang=js"
import style0 from "./officeVehicleList.vue?vue&type=style&index=0&id=f8fd1484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fd1484",
  null
  
)

export default component.exports